<template>
  <div v-if="isDisplay" :class="{ parallel: isParallel }" class="timeline">
    <div v-if="isDispFacebook" class="fac-facebook">
      <h2>Facebook公式ページ</h2>
      <iframe
        :width="dataWidth"
        :src="facebookUrl"
        class="fb-page"
        height="500"
        style="border:none;overflow:hidden"
        scrolling="no"
        frameborder="0"
        allowfullscreen="true"
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
      ></iframe>
    </div>
    <div v-if="isDispTwitter" class="fac-twitter">
      <h2>Twitter公式アカウント</h2>
      <a
        :href="twitterUrl"
        class="twitter-timeline"
        data-width="500"
        data-height="500"
        >{{ twitterTitle }}</a
      >
    </div>
  </div>
</template>

<script>
import { methods } from '@/utils/methods'
export default {
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dataWidth: 0,
      dataTimer: 0
    }
  },
  computed: {
    isDispFacebook() {
      return this.detail.facebook
    },
    isDispTwitter() {
      // ieからのアクセスは非表示にする
      const isIe = methods.isIe()
      return this.detail.twitter && !isIe
    },
    isDisplay() {
      if (this.isDispFacebook || this.isDispTwitter) {
        return true
      }
      return false
    },
    isParallel() {
      return this.isDispFacebook && this.isDispTwitter
    },
    facebookUrl() {
      if (!this.isDispFacebook) return ''
      return (
        'https://www.facebook.com/plugins/page.php?href=' +
        this.$options.filters.urlencode(
          'https://www.facebook.com/' + this.detail.facebook + '/'
        ) +
        '&tabs=timeline&width=' +
        this.dataWidth +
        '&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=' +
        process.env.FACEBOOK_APP_ID
      )
    },
    twitterUrl() {
      if (!this.isDispTwitter) return ''
      return 'https://twitter.com/' + this.detail.twitter + '?ref_src=twsrc^tfw'
    },
    twitterTitle() {
      if (!this.isDispTwitter) return ''
      return 'Tweets by ' + this.detail.twitter
    }
  },
  mounted() {
    if (this.isDispFacebook) {
      window.addEventListener('resize', this.onResize)
      this.resizeDataWidth()
    }
  },
  /* istanbul ignore next */
  destroyed() {
    if (this.isDispFacebook) {
      window.removeEventListener('resize', this.onResize)
    }
  },
  methods: {
    resizeDataWidth() {
      let fbWidth = document.querySelector('.fac-facebook').clientWidth
      if (fbWidth > 500) {
        fbWidth = 500
      }
      if (this.dataWidth !== fbWidth) {
        this.dataWidth = fbWidth
        return true
      } else {
        return false
      }
    },
    onResize() {
      if (this.dataTimer != null) {
        window.clearTimeout(this.dataTimer)
      }
      this.dataTimer = window.setTimeout(() => {
        this.resizeDataWidth()
      }, 200)
    }
  }
}
</script>
